/* eslint-disable @typescript-eslint/camelcase */
/* globals $ */
import { get as ldGet } from 'lodash'
import intl from 'react-intl-universal'

import { storyLockedOrReadonlyAccessor } from '~/redux/appReducer'
import { hasPermission } from '../services/permission'

const mapStateToThis = (state) => ({
  isLockedOrReadonly: storyLockedOrReadonlyAccessor(state),
})

function navActionsController(
  $rootScope,
  $location,
  storyService,
  publishService,
  tabService,
  siteService,
  toastr,
  $ngRedux
) {
  this.intl = intl

  let unsubscribers = []

  this.$onInit = () => {
    // TODO - Eric - load from init data
    this.canDelete = hasPermission(window.userRolesAuth.story.deleteStory)

    this.undo = storyService.undo
    this.redo = storyService.redo
    this.story = this.storyObj
    this.tab = tabService.get()
    this.displaySendToPrint = $rootScope.globalSettings.displaySendToPrint

    this.setPreviewUrl()
    this.setPublishedLinkUrl()
    unsubscribers.push($ngRedux.connect(mapStateToThis)(this))
  }

  this.sendToPrint = function() {
    storyService.sendToPrint(this.story._id)
  }.bind(this)

  this.canCloneStory = () => {
    return hasPermission(window.userRolesAuth.story.cloneStory)
  }

  this.cloneStory = () => {
    storyService.save(true, null, null, true)
  }

  unsubscribers.push(
    $rootScope.$on('DISPATCH', (sender, action) => {
      switch (action && action.event && action.event.type) {
        case 'STORY_FETCH_SUCCESS':
          this.tab = tabService.get({ story: action.story })
          break
        case 'UNDO_REDO_STATE':
          this.storyState = action.event.states
          break
      }
    })
  )

  unsubscribers.push(
    $rootScope.$on('CHANGE_TAB', (sender, action) => {
      this.tab = action.tab.id
    })
  )

  this.sendToPrint = function() {
    storyService.sendToPrint(this.story._id, this.story.revision.revision_id)
  }.bind(this)

  this.findReplaceToggle = () => {
    $rootScope.$broadcast('TOGGLE_FIND_REPLACE', {})
  }

  this.setPreviewUrl = () => {
    const {
      org_settings: { pageBuilderPrvURL = '', pageBuilderPrvDomain } = {},
    } = window

    this.previewURL = ''
    if (!pageBuilderPrvURL) {
      return
    }

    let url = pageBuilderPrvURL
    storyService.getStory().then((story) => {
      const regExp = url.indexOf('{') > -1 ? /\{[^{]*\}/g : /:[^/:]*/g
      const params = url.match(regExp)
      if (params) {
        params.forEach((key) => {
          const path = key.replace(/^:/, '').replace(/[{}]/g, '')
          const replacement = ldGet(story, path)
          if (replacement) {
            url = url.replace(key, replacement)
          }
        })
      }
      this.previewURL = `${url}`
      if (pageBuilderPrvDomain && pageBuilderPrvDomain.length > 0) {
        this.previewURL =
          this.previewURL +
          `?pbdomain=${encodeURIComponent(pageBuilderPrvDomain)}`
      }
    })
  }

  // not sure why this does this....
  unsubscribers.push(
    $rootScope.$on('DISPATCH', (sender, action) => {
      if (action.type === 'STORY_FETCH_SUCCESS') {
        this.tab = tabService.get({ story: action.story })
        tabService.set(this.tab)
      }
    })
  )

  this.setPublishedLinkUrl = () => {
    publishService.getPublishState().then(
      (pubState) => {
        this.publish_state = pubState

        // Well since wirefeeds will not set primary site (we need to check multiple places.)

        const isPublished =
          this.publish_state.isPublished ||
          this.story.additional_properties.is_published
        const primary =
          this.story.taxonomy && this.story.taxonomy.primary_section
        const sections =
          this.story.taxonomy &&
          this.story.taxonomy.sections &&
          this.story.taxonomy.sections.length &&
          this.story.taxonomy.sections[0]

        if (isPublished && (primary || sections)) {
          const basePath = siteService.getBasePathForSite(primary || sections)
          this.publishedStoryUrl = basePath + this.story.canonical_url
        }
      },
      (...args) => {
        toastr.error(intl.get('navActions.setPublishedLinkUrl.error'))
        console.log('fail', args)
      }
    )
  }

  unsubscribers.push(
    $rootScope.$on('ELLIPSIS_STORY_LOADED', () => {
      this.setPreviewUrl()
    })
  )

  unsubscribers.push(
    $rootScope.$on('ELLIPSIS_STORY_PUBLISHED', (event, storyId) => {
      this.setPublishedLinkUrl()
    })
  )

  const toggleNavbarOnScroll = () => {
    var isHidden = $('.nav-main').outerHeight() <= $(this).scrollTop()
    $('.nav-actions').toggleClass('navbar-fixed-top', isHidden)
  }

  $(window).on('scroll', toggleNavbarOnScroll)

  this.$onDestroy = () => {
    $(window).off('scroll', toggleNavbarOnScroll)
    unsubscribers.forEach((f) => f())
    unsubscribers = []
  }
}

export default [
  '$rootScope',
  '$location',
  'storyService',
  'publishService',
  'tabService',
  'siteService',
  'toastr',
  '$ngRedux',
  navActionsController,
]
